module.exports = __webpack_public_path__ + "static/media/connect@2x.b394626d.png";